export default __webpack_public_path__ + "static/media/screenBlock16.442e9d35.jpg";